import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cd5677e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-with-text" }
const _hoisted_2 = { class: "overlay" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-content" }

import { withDefaults } from "vue";
import { getImage, getTranslate } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerWithText',
  props: {
    backgroundImage: null,
    backgroundImageLocal: { type: Boolean, default: true },
    height: { default: "31rem" },
    logo: null,
    logoLocal: { type: Boolean, default: true },
    logoWidth: { default: "13rem" },
    title: null,
    subtitle: null,
    titleFont: { default: "Roboto-Bold" },
    titleFontSize: { default: "2.8rem" },
    subtitleFont: { default: "Roboto" },
    subtitleFontSize: { default: "1.3rem" },
    textColor: { default: "#fff" },
    textPosition: { default: "left" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "0ab8e46a": (__props.height),
  "25873391": (__props.textPosition === 'center' ? 'center' : __props.textPosition === 'right' ? 'flex-end' : 'flex-start'),
  "21b65bb7": (__props.logoWidth),
  "ff80db78": (__props.titleFontSize),
  "3fc93f12": (__props.textColor),
  "409538cc": (__props.subtitleFontSize)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: "background",
      style: _normalizeStyle({
        backgroundImage: `url(${_unref(getImage)(
          __props.backgroundImage,
          __props.backgroundImageLocal
        )})`,
      })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.logo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _unref(getImage)(__props.logo, __props.logoLocal),
                  alt: "logo"
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (__props.title)
              ? (_openBlock(), _createElementBlock("h1", {
                  key: 0,
                  class: _normalizeClass(['title', __props.titleFont])
                }, _toDisplayString(_unref(getTranslate)(__props.title)), 3))
              : _createCommentVNode("", true),
            (__props.subtitle)
              ? (_openBlock(), _createElementBlock("h2", {
                  key: 1,
                  class: _normalizeClass(['subtitle', __props.subtitleFont])
                }, _toDisplayString(_unref(getTranslate)(__props.subtitle)), 3))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 4)
  ]))
}
}

})